import type { PushProviderFormProps } from '../types';
import { PushProviderPanel } from './push-provider-panel';
import { useApnsForm } from './use-apns-form';

export function ApnsProviderForm(props: PushProviderFormProps) {
  const form = useApnsForm(props);
  return <PushProviderPanel {...props} form={form} />;
}
